import { AvailableSections, UserProps, UserSettings } from '@/interfaces/models/user';
import Image from '@/models/image';
import PlaceDate from '@/utils/placeDate';

enum Roles {
  ROLE_SUPER_ADMIN = 'ROLE_SUPER_ADMIN',
  ROLE_ADMIN = 'ROLE_ADMIN',
  ROLE_USER = 'ROLE_USER'
}

export default class User {
  public availableSections: AvailableSections;
  public avatar: Image = new Image();
  public createdAt: number;
  public email: string;
  public firstName: string;
  public id: string;
  public isHavePinCode: boolean;
  public language: string;
  public lastName: string;
  public phone: string;
  public position: string;
  public role: string;
  public pinCode: string;
  public settings: UserSettings;

  [key: string]: any;

  constructor(user: UserProps) {
    this.availableSections = user.availableSections;

    if (user.avatar) {
      this.avatar = new Image(user.avatar);
    }

    this.createdAt = user.createdAt;
    this.email = user.email;
    this.firstName = user.firstName;
    this.id = user.id;
    this.isHavePinCode = user.isHavePinCode;
    this.language = user.language;
    this.lastName = user.lastName;
    this.phone = user.phone;
    this.position = user.position;
    this.role = user.role;
    this.pinCode = user.pinCode;
    this.settings = user.settings;
  }

  get date(): PlaceDate {
    return new PlaceDate(this.createdAt);
  }

  get fullName() {
    return `${this.firstName} ${this.lastName}`;
  }

  get isStaff() {
    return !this.isAdmin && !this.isOwner;
  }

  get isAdmin() {
    return this.isRoleAdmin || this.isOwner;
  }

  set isAdmin(isAdmin: boolean) {
    if (this.isOwner) {
      return;
    }

    if (isAdmin) {
      this.role = Roles.ROLE_ADMIN;
    } else {
      this.role = Roles.ROLE_USER;
    }
  }

  get isRoleAdmin() {
    return Roles.ROLE_ADMIN === this.role;
  }

  get isOwner() {
    return Roles.ROLE_SUPER_ADMIN === this.role;
  }

  mergeWithNewFields(userProps: UserProps) {
    for (let key in userProps) {
      if (userProps.hasOwnProperty(key) && this.hasOwnProperty(key)) {
        switch (key) {
          case 'avatar': {
            if (userProps.avatar) {
              this.avatar = new Image(userProps.avatar);
            } else {
              this.avatar = new Image();
            }

            break;
          }

          default: {
            this[key] = userProps[key];
          }
        }
      }
    }
  }

  removeImage() {
    this.avatar = new Image();
  }
}
